import { http } from '@/api/http';

export interface ContactUsRequestBody {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export async function postContactUs(body: ContactUsRequestBody): Promise<void> {
  await http.post('/system/contactUs/user/contactUs', body);
}
